import React from 'react';
import { HOME_SEO } from '../data/dgpt';
import { usePageMeta, canonicalUrl } from '../hooks/usePageMeta';
import { HomeHero } from '../components/home/HomeHero';
import { ExploreSolutions } from '../components/home/ExploreSolutions';
import { MeetAgentsSection } from '../components/home/MeetAgentsSection';
import { VcProofSection } from '../components/home/VcProofSection';
import { WorkflowBuilderSection } from '../components/home/WorkflowBuilderSection';
import { PartnersCallout } from '../components/home/PartnersCallout';
import { HumanControl } from '../components/platform/HumanControl';
import { SecuritySection } from '../components/home/SecuritySection';
import { ProcessCta } from '../components/platform/ProcessCta';
import { MobileStickyCta } from '../components/dgpt/MobileStickyCta';
export function Home() {
  usePageMeta({
    title: HOME_SEO.title,
    description: HOME_SEO.description,
    path: '/',
    keywords: [...HOME_SEO.keywords],
    jsonLd: [{
      '@type': 'SoftwareApplication',
      name: 'DiligenceGPT™',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      url: canonicalUrl('/'),
      description: HOME_SEO.description,
      publisher: {
        '@id': 'https://www.startupfuel.com/#organization'
      }
    }]
  });
  return <>
      <main id="main" data-id="element-1456" data-mp="2mw8jth35d5h2">
        <HomeHero data-id="element-1457" data-mp="2mwqrraz6984t" />
        <ExploreSolutions data-id="element-1458" data-mp="2mzctgtzdstf4" />
        <MeetAgentsSection data-id="element-1459" data-mp="2hyfhx08vmxml" />
        <VcProofSection data-id="element-1460" data-mp="2hyp6cje9wwq6" />
        <WorkflowBuilderSection data-id="element-1461" data-mp="2i009cgzwa0g8" />
        <PartnersCallout data-id="element-1462" data-mp="2d7gu7flk6x9b" />
        <HumanControl placement="home" data-id="element-1463" data-mp="2d65rlj3unvjs" />
        <SecuritySection data-id="element-1464" data-mp="2d548qsgle4ri" />
        <ProcessCta placement="home" data-id="element-1465" data-mp="287uhr8dk1l1k" />
      </main>
      <MobileStickyCta data-id="element-1466" data-mp="288nle0h7vufh" />
    </>;
}